module.exports = __webpack_public_path__ + "static/media/devops.01f0e22b.png";